import React, { useEffect, useState } from "react";
import Modal from "./Modal";
import {
  Button,
  Checkbox,
  DatePickerComp,
  Input,
  Select,
  Textarea,
  TimePickerComp,
} from "../Form";
import { BiChevronDown } from "react-icons/bi";
import { memberData, servicesData } from "../Datas";
import { HiOutlineCheckCircle, HiOutlineTrash } from "react-icons/hi";
import { toast } from "react-hot-toast";
import { BsFileEarmarkPerson } from "react-icons/bs";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  createCita,
  getCitas,
  updateCita,
  deleteCita,
} from "../../redux/features/citasSlice";
import SearchBar from "../SearchBar";
import { useForm } from "react-hook-form";
import ConfirmationAlert from "../ConfirmationAlert";
import NewMedicalRecode from "../../screens/Patients/NewMedicalRecode";
import { FaNotesMedical } from "react-icons/fa";
import NewPatientFast from "./NewPatientFast";
import { getPatients } from "../../redux/features/patientSlice";
import {
  getVisitasByCitaId,
  resetVisita,
} from "../../redux/features/visitasSlice";

// edit member data
const doctorsData = memberData.map((item) => {
  return {
    id: item.id,
    name: item.title,
  };
});

function AddAppointmentModal({
  closeModal,
  isOpen,
  datas,
  currentDay,
  operation,
  patients,
}) {
  const [services, setServices] = useState(servicesData[0]);
  const activeServices = servicesData.filter(
    (service) => service.status === true
  );
  const [startDate, setStartDate] = useState(() => {
    if (datas?.id) return new Date(datas.fecha);
    if (currentDay) return new Date(currentDay.date);
    return new Date();
  });

  const [startTime, setStartTime] = useState(() => {
    if (datas?.id) return new Date(datas.start);
    if (currentDay) return new Date(currentDay.start);
    return new Date();
  });

  const [endTime, setEndTime] = useState(() => {
    if (datas?.id) return new Date(datas.end);
    if (currentDay) return new Date(currentDay.end);
    const defaultEnd = new Date();
    defaultEnd.setMinutes(defaultEnd.getMinutes() + 30);
    return defaultEnd;
  });

  const [openPatient, setOpenPatient] = useState(false);
  const [selected, setSelected] = useState(null);
  const navigate = useNavigate();

  const {
    register,
    setValue,
    getValues,
    handleSubmit,
    formState: { errors },
  } = useForm({});

  const onSubmit = async (data) => {
    if (!selected?.id && !datas.id) {
      toast.error("Seleccione al Paciente Primero!");
      return;
    }
    if (datas.id) {
      data.patient_id = datas.patient_id;
    } else {
      if (selected?.id) data.patient_id = selected.id;
      else toast.error("Seleccione al Paciente!!!", { duration: 5000 });
    }

    data.fecha = startDate.toISOString();

    const horaInicio = new Date(startDate);
    horaInicio.setHours(startTime.getHours(), startTime.getMinutes());
    data.hora_inicio = horaInicio.toISOString();

    const horaFin = new Date(startDate);
    horaFin.setHours(endTime.getHours(), endTime.getMinutes());
    data.hora_fin = horaFin.toISOString();

    data.tipo_evento = services.name;

    ConfirmationAlert({
      title: `${datas?.id ? "Actualizar" : "Registrar"} Cita`,
      text: `¿Esta seguro de ${
        datas?.id ? "actualizar" : "registrar"
      } la cita?`,
      onAccept: async () => {
        if (datas?.id && datas?.estado === "en curso") {
          data.id = datas.id;
          const res = await operation.dispatch(updateCita(data));
          if (res.error) {
            toast.error(
              "Ocurrio un error al actualizar la cita: " + res.error,
              { duration: 5000 }
            );
          } else {
            operation.update({
              ...datas,
              motivo: res.payload.motivo,
              tipo_evento: res.payload.tipo_evento,
              fecha: res.payload.fecha,
              start: res.payload.hora_inicio,
              end: res.payload.hora_fin,
              comentarios: res.payload.comentarios,
            });
            operation.dispatch(getCitas());
            operation.dispatch(getPatients());
            toast.success("Cita actualizada exitosamente!", { duration: 5000 });
          }
        } else {
          const res = await operation.dispatch(createCita(data));
          if (res.error) {
            toast.error("Ocurrio un error al crear la cita: " + res.error, {
              duration: 5000,
            });
          } else {
            operation.update({
              ...datas,
              motivo: res.payload.motivo,
              tipo_evento: res.payload.tipo_evento,
              fecha: res.payload.fecha,
              start: res.payload.hora_inicio,
              end: res.payload.hora_fin,
              comentarios: res.payload.comentarios,
            });
            operation.dispatch(getCitas());
            operation.dispatch(getPatients());
            //TODO: Crear visita si es una cita tipo reconsulta
            if (data.tipo_evento === "Re Consulta") {
              const visitaResponse = await operation.dispatch(
                getVisitasByCitaId(res?.payload?.id)
              );
              if (visitaResponse?.error) {
                toast.error(
                  `No se pudo iniciar la atención: ${visitaResponse.error}`,
                  { duration: 5000 }
                );
              } else {
                toast.success("Datos de visita guardados con exito!", {
                  duration: 5000,
                });
              }
            }
            toast.success("Cita creada exitosamente!", { duration: 5000 });
          }
        }
        closeModal();
      },
    });
  };

  const onUpdate = async (data) => {
    ConfirmationAlert({
      title: "Inicio de Atención",
      text: "¿Esta seguro de iniciar la atención?",
      onAccept: async () => {
        const res = await operation.dispatch(
          updateCita({ ...datas, estado: "cerrada" })
        );
        if (datas?.id) {
          data.id = datas.id;
          if (res.error) {
            toast.error(
              "Ocurrio un error al actualizar la cita: " + res.error,
              { duration: 5000 }
            );
          } else {
            operation.dispatch(getCitas());
            operation.dispatch(getPatients());
            operation.dispatch(getVisitasByCitaId(res?.payload?.id));
            toast.success("Cita actualizada exitosamente!", { duration: 5000 });
            setTimeout(() => {
              navigate(`/patients/preview/${datas.patient.id}`);
            }, 500);
          }
        }
      },
    });
  };

  const onDelete = async () => {
    ConfirmationAlert({
      title: "Eliminar Cita",
      text: "¿Está seguro de eliminar esta cita?",
      onAccept: async () => {
        const res = await operation.dispatch(deleteCita(datas.id));
        if (res.error) {
          toast.error("Ocurrió un error al eliminar la cita: " + res.error, {
            duration: 5000,
          });
        } else {
          operation.dispatch(getCitas());
          operation.dispatch(getPatients());
          toast.success("Cita eliminada exitosamente!", { duration: 5000 });
          closeModal();
        }
      },
    });
  };

  // const handleAtencion = () => {
  //   onUpdate();
  //   operation.dispatch(resetVisita());
  // }
  // set data
  useEffect(() => {
    if (datas?.id) {
      setServices(
        servicesData.find((service) => service.name === datas?.tipo_evento)
      );

      setStartTime(datas?.start);
      setEndTime(datas?.end);
      setStartDate(new Date(datas.fecha));
      setValue("motivo", datas?.motivo);
      setValue("comentarios", datas?.comentarios);
    }
  }, [datas?.id]);

  return (
    <Modal
      closeModal={closeModal}
      isOpen={isOpen}
      title={datas?.title ? "Editar Cita" : "Nueva Cita"}
      width={"max-w-3xl"}
    >
      <div className="flex-colo gap-6">
        <div className="grid sm:grid-cols-12 gap-4 w-full items-center">
          {openPatient && (
            <NewPatientFast
              open={openPatient}
              setOpen={setOpenPatient}
              setPatient={setSelected}
            />
          )}
          <div className="sm:col-span-10">
            {datas?.id ? (
              <div className="flex flex-col sm:flex-row justify-between w-full gap-4">
                <p>
                  <span className=" font-semibold"> Paciente: </span>{" "}
                  {datas?.patient?.persona?.nombre}{" "}
                  {datas?.patient?.persona?.apellidos}
                </p>
                <p className="mt-2">
                  <span className=" font-semibold">Estado: </span>
                  {datas.estado}
                </p>
              </div>
            ) : (
              <SearchBar
                placeholder="Escriba nombre o CI para buscar al paciente"
                data={patients}
                setSelected={setSelected}
                value={
                  selected
                    ? `${
                        selected.persona.ci.length > 10
                          ? selected.persona.ci.slice(0, 8)
                          : selected.persona.ci
                      } - ${selected.persona.nombre} ${
                        selected.persona.apellidos
                      }`
                    : ""
                }
                setOpen={setOpenPatient}
              />
            )}
          </div>
        </div>

        <div className="grid sm:grid-cols-3 gap-4 w-full">
          <div className="flex w-full flex-col gap-3">
            <p className="text-black text-sm">Tipo de evento</p>
            <Select
              selectedPerson={services}
              setSelectedPerson={setServices}
              datas={activeServices}
              disabled={datas?.id && datas?.estado !== "en curso" && true}
            >
              <div className="w-full flex-btn text-textGray text-sm p-4 border border-border font-light rounded-lg focus:border focus:border-subMain">
                {services?.name} <BiChevronDown className="text-xl" />
              </div>
            </Select>
          </div>
          {/* date */}
          <DatePickerComp
            label="Fecha"
            startDate={startDate}
            onChange={(date) => setStartDate(date)}
            disabled={datas?.id && datas?.estado !== "en curso" && true}
          />
        </div>

        <div className="grid sm:grid-cols-2 gap-4 w-full">
          <TimePickerComp
            label="Hora Inicio"
            startDate={startTime}
            onChange={(date) => {
              setStartTime(date);
              setEndTime(new Date(date.getTime() + 30 * 60000));
            }}
            disabled={datas?.id && datas?.estado !== "en curso" && true}
          />
          <TimePickerComp
            label="Hora Fin"
            startDate={endTime}
            onChange={(date) => setEndTime(date)}
            disabled={datas?.id && datas?.estado !== "en curso" && true}
          />
        </div>
        {/* des */}
        <Textarea
          register={register("motivo", {
            required: "El motivo de la cita es requerido.",
          })}
          name="motivo"
          setValue={setValue}
          getValue={getValues}
          label="Motivo de la Cita"
          placeholder={
            datas?.message ? datas.message : "El paciente refiere malestar....."
          }
          color={true}
          rows={5}
          error={errors?.motivo}
          disabled={datas?.id && datas?.estado !== "en curso" && true}
        />

        {datas?.id && (
          <Textarea
            register={register("comentarios")}
            name="comentarios"
            setValue={setValue}
            getValue={getValues}
            label="Notas de la cita"
            placeholder={datas?.comentarios ?? "No se tienen ninguna nota."}
            disabled={
              datas?.tipo_evento.toLowerCase() !== "re consulta" &&
              datas?.estado !== "en curso"
                ? true
                : false
            }
            color={true}
            rows={5}
            error={errors?.motivo}
          />
        )}

        {/* buttones */}
        <div
          className={"flex flex-col sm:flex-row justify-between w-full gap-4"}
        >
          {datas?.id &&
            (datas?.estado === "cerrada" ? (
              <Link
                to={`/patients/preview/${datas.patient.id}`}
                className="bg-subMain h-12 rounded-lg flex justify-center items-center text-white text-center w-full"
              >
                <BsFileEarmarkPerson />
                Paciente
              </Link>
            ) : (
              <Button
                label={`${
                  datas?.tipo_evento === "Analisis o Laboratorio"
                    ? "Abrir Análisis o Laboratorio"
                    : "Inicar Atención"
                }`}
                onClick={handleSubmit(onUpdate)}
                Icon={FaNotesMedical}
              />
            ))}
          {datas?.id && datas?.estado === "en curso" && (
            <Button
              label={`Editar cita`}
              Icon={HiOutlineCheckCircle}
              onClick={handleSubmit(onSubmit)}
            />
          )}
          {!datas?.id && (
            <Button
              label={`Agendar Cita`}
              Icon={HiOutlineCheckCircle}
              onClick={handleSubmit(onSubmit)}
            />
          )}
          {datas?.id && (
            <Button
              label="Eliminar Cita"
              Icon={HiOutlineTrash}
              onClick={onDelete}
              className="bg-red-500 text-white"
            />
          )}
        </div>
      </div>
    </Modal>
  );
}

export default AddAppointmentModal;
